import { useSyncExternalStore, type ReactNode } from "react";

const emptySubscribe = () => () => {};
const returnTrue = () => true;
const returnFalse = () => false;

/**
 * Renders children only on the client (after hydration).
 * Uses useSyncExternalStore to safely defer to client rendering,
 * preventing SSR from attempting to render browser-only components.
 */
export function ClientOnly({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
  const isClient = useSyncExternalStore(emptySubscribe, returnTrue, returnFalse);
  return isClient ? <>{children}</> : <>{fallback ?? null}</>;
}
